import { takeLatest, call, put } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import {
  fetchAuthenticatedUserSuccess,
  logoutSuccess,
  loginSuccess,
  loginError,
  setToken,
} from './actions';
import { startAction, stopAction } from '../loading/actions';
import { enqueueSnackbar } from '../notifier/actions';
import {
  LOGIN_REQUEST,
  FETCH_AUTHENTICATED_USER_REQUEST,
  LOGOUT_REQUEST,
} from './actionTypes';
import { PROJECT_LIST } from 'routes';
import authService from 'services/AuthService';
import { HTTP_STATUS_CODES } from 'consts';
import { removeItem } from '../../utils/localStorage';
import { setSnackbar } from '../snackbar/actions';

export function* authorize({ type, email, password }) {
  try {
    yield put(startAction(type));
    const res = yield call(authService.login, { email, password });
    yield put(loginSuccess());
    yield put(setToken('token', res.token));
    yield put(push(PROJECT_LIST));
  } catch (error) {
    if (error && error.status === HTTP_STATUS_CODES.UNAUTHORIZED) {
      yield put(
        enqueueSnackbar({
          message: error.data.message,
        })
      );
    }
    yield put(loginError());
  } finally {
    yield put(stopAction(type));
  }
}

export function* fetchUser({ type }) {
  yield put(startAction(type));
  try {
    const user = yield call(authService.fetchAuthenticatedUser);
    yield put(fetchAuthenticatedUserSuccess(user));
  } catch (error) {
    console.log({ error });
    yield put(
      setSnackbar({
        open: true,
        severity: 'error',
        message: 'Something went wrong!',
      })
    );
  } finally {
    yield put(stopAction(type));
  }
}

export function* logout() {
  try {
    yield put(logoutSuccess());
    yield call(removeItem, 'token');
  } catch (error) {
    //
  }
}

export default function* authSaga() {
  yield takeLatest(LOGIN_REQUEST, authorize);
  yield takeLatest(FETCH_AUTHENTICATED_USER_REQUEST, fetchUser);
  yield takeLatest(LOGOUT_REQUEST, logout);
}
